import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';

export interface INotesAddButtonProps {
  onClick: () => void;
  className?: string;
}

const NotesAddButton = ({ onClick, className }: INotesAddButtonProps) => {
  const { t } = useTranslation('common');
  return (
    <button
      onClick={onClick}
      onMouseDown={(event) => event.preventDefault()}
      type='button'
      className={classNames(styles.container, className)}
    >
      {t('notes.add_note')}
    </button>
  );
};

export default NotesAddButton;
